import React from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Pagination,
  Stack,
  useMediaQuery,
} from '@mui/material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ManIcon from '@mui/icons-material/Man';
import {
  BackdropLoading,
  BookButton,
  BookSearchField,
  BookSearchDropDownField,
  CardComponent,
} from '../../components';

import { WHITE_COLOR, GREY_COLOR } from '../../styles/constants';
import { TableHeadComponent, TableRows } from '../../components';
import UsersModal from '../modals/users';
import { useTheme } from '@mui/material/styles';
import { useUsers } from './hooks/users.hook';
import { useStyles } from './users.style';
import AddIcon from '@mui/icons-material/Add';

const UsersTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    userData,
    action,
    userCount,
    open,
    setOpen,
    singleUser,
    tableCells,
    actionsIcons,
    limit,
    page,
    isLoading,
    searchKey,
    handleGetUsers,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleUserSearch,
    handleDropDown,
  } = useUsers();

  const dataIcons = [
    { id: 'name', title: 'Name', gridTitleSize: 5, gridSize: 6 },
    {
      id: 'direction',
      title: 'direction',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <ContactPhoneIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
  ];

  return (
    <Box component='div' sx={isMobile && { paddingBottom: 10 }}>
      {open && (
        <UsersModal
          tableCells={tableCells}
          open={open}
          setOpen={setOpen}
          singleUser={singleUser}
          action={action}
          handleGetUsers={handleGetUsers}
        />
      )}
      <BackdropLoading open={isLoading} />
      <Box
        component='div'
        sx={{
          width: '100%',
          position: isMobile && 'sticky',
          top: isMobile && '7rem',
          zIndex: isMobile && 1000,
          background: 'white',
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={2} lg={2}>
          <BookSearchDropDownField
              type='select'
              searchKey={searchKey}
              handleDropDown={handleDropDown}
              sx={{ width: isMobile ? '100%' : '100%' }}
              selectOptions={[{text: "Name", value: "name"}, {text: "Email", value: "email"}]}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <BookSearchField
              type='text'
              handleSearch={handleUserSearch}
              sx={{ width: isMobile ? '100%' : '50%' }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <BookButton
              onSubmit={handleAdd}
              title='Add User'
              type='primary'
              variant='contained'
              icon={<AddIcon />}
            />
          </Grid>
        </Grid>
      </Box>
      {isMobile ? (
        <>
          {userData &&
            Object.keys(userData).length > 0 &&
            userData?.map(row => (
              <CardComponent
                key={'userDara' + row.id}
                sx={{
                  background: GREY_COLOR.GHOSTWHITE,
                  width: '97%',
                  margin: '20px 5px 5px 5px',
                }}
                classBorder={
                  Object.keys(row['measurement']).length > 0
                    ? classes.statusCompleted
                    : classes.statusPending
                }
                titleStyle={classes.titleStyle}
                uniqueKey='-userCrud'
                rows={row}
                dataIcons={dataIcons}
                tableCells={tableCells}
                actionsIcons={actionsIcons}
                handleActionClick={handleActionClick}
              />
            ))}
          <Stack className={classes.paginationStyle} spacing={2}>
            <Pagination
              count={calculatePagesCount(limit, userCount)}
              page={page + 1}
              onChange={(event, newPage) => handleChangePage(true, newPage)}
              color='primary'
            />
          </Stack>
        </>
      ) : (
        <>
          <TableContainer
            sx={{
              width: '100%',
              background: WHITE_COLOR,
            }}
          >
            <Table sx={{ minWidth: '100%' }} aria-label='simple table'>
              <TableHeadComponent tableCells={tableCells} />
              <TableBody>
                <TableRows
                  uniqueKey='-userCrud'
                  tableCells={tableCells}
                  rows={userData}
                  actionsIcons={actionsIcons}
                  handleActionClick={handleActionClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={userCount}
            page={page}
            onPageChange={(event, newPage) => handleChangePage(false, newPage)}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[25, 50, 100, 250, 500, 750, 1000]}
          />
        </>
      )}
    </Box>
  );
};
export default UsersTable;
